import { useRouter } from '../../hooks/useRouter';
import { LoadingButton } from '../buttons/LoadingButton';
import { useGuardSignIn } from '../../hooks/useGuardSignIn';
import { useAuth } from '../../contexts/AuthContext';
import { useCallback } from 'react';
import { useCreateEventWizard } from '../../hooks/organizer/useCreateEventWizard';

export const CreateEventButton = () => {
  const router = useRouter();
  const { guardSignIn } = useGuardSignIn();
  const { user } = useAuth();
  const { open: openNewEventDialog } = useCreateEventWizard();
  const redirectToOrganizer = useCallback(() => {
    if (router.isReady && user?.uid) {
      openNewEventDialog('Select Game');
    }
  }, [openNewEventDialog, router.isReady, user?.uid]);

  const redirectToOrganizerWithGuard = guardSignIn(
    redirectToOrganizer,
    'Create Event?',
    'Sign in',
  );
  return (
    <LoadingButton
      variant="containedHorizontal"
      color="primary"
      onClick={async () => {
        return redirectToOrganizerWithGuard();
      }}
    >
      Create event
    </LoadingButton>
  );
};
